import React, { useMemo, useState } from "react";
import { Button, ButtonBase, CircularProgress } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/styles";
import styles from "./Style.module.css";
import CustomAutoComplete from "../../../../../../../components/FormFields/AutoCompleteText/CustomAutoComplete";
import { useSelector } from "react-redux";
import SnackbarUtils from "../../../../../../../libs/SnackbarUtils";

const useStyles = makeStyles((theme) => ({
  flex: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    color: "blue",
    textDecoration: "underline",
  },
  textField: {
    width: "100%",
  },
  closeBtn: {
    position: "absolute",
    right: "10px",
    top: "10px",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteDialog = ({
  isOpen,
  handleToggle,
  handleSubmit,
  isSubmitting,
  isExit,
  exitMember,
  empId,
  groupMemberList = [],
  isGroupAdmin,
}) => {
  const [replaceAdmin, setReplaceAdmin] = useState(null);
  const classes = useStyles();
  const {
    user: { id: user_id },
  } = useSelector((state) => state.auth);

  const memberList = useMemo(() => {
    return groupMemberList
      ?.filter((val) => val?.id !== user_id)
      ?.map((val) => {
        return {
          ...val,
          label: `${val?.name} (${val?.emp_code})`,
        };
      });
  }, [groupMemberList, user_id]);

  const handleConfirm = () => {
    if (isGroupAdmin && isExit && !replaceAdmin?.id) {
      SnackbarUtils.error("Please select the replacing Group Admin");
      return;
    }

    if (isGroupAdmin && isExit) {
      handleSubmit({ new_admin_id: replaceAdmin?.id });
    } else {
      handleSubmit();
    }
  };

  return (
    <div>
      <Dialog
        onBackdropClick={() => {}}
        keepMounted
        fullWidth={true}
        maxWidth={"sm"}
        TransitionComponent={Transition}
        open={isOpen}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/*<DialogTitle id="alert-dialog-title">*/}
        <div className={styles.resetPasswordWrapper}>
          <div className={styles.resetWrapper}>
            <ButtonBase
              classes={{ root: classes.closeBtn }}
              onClick={handleToggle}
            >
              <Close />
            </ButtonBase>
          </div>
          {exitMember ? (
            <div className={styles.headerWrap}>
              <div className={styles.upperFlex21}>Remove Member</div>
              <div className={styles.newLine}></div>
              <div className={styles.upperFlex2}>
                Are you sure want to remove <b>{empId?.name}</b> from this
                group?
                <br />
                They will no longer have access to group messages, files, or
                updates
                <br />
              </div>
            </div>
          ) : (
            <div className={styles.headerWrap}>
              <div className={styles.upperFlex21}>
                {isGroupAdmin && isExit
                  ? "Transfer Admin Role"
                  : isExit
                  ? "Leave Group"
                  : "Delete Group"}
              </div>
              <div className={styles.newLine}></div>
              <div className={styles.upperFlex2}>
                {isGroupAdmin && isExit
                  ? "As the current admin, you must assign a new admin before exiting. Please select a member to transfer admin rights to."
                  : isExit
                  ? "Are you sure you want to leave this group? You will no longer receive messages or updates from this group."
                  : "Are you sure you want to Delete this group"}

                <br />
              </div>
            </div>
          )}
          {isGroupAdmin && isExit && (
            <div>
              <br />
              <CustomAutoComplete
                autoCompleteProps={{
                  freeSolo: false,
                  getOptionLabel: (option) => option?.label,
                }}
                dataset={memberList}
                datasetKey={"label"}
                onTextChange={(text, value) => {
                  setReplaceAdmin(text);
                }}
                variant={"outlined"}
                label={"Select Admin"}
                // name={"g1"}
                value={replaceAdmin}
              />
            </div>
          )}

          <div
            className={styles.printFlex}
            style={
              isGroupAdmin && isExit
                ? { paddingTop: "30px", paddingBottom: "30px" }
                : {}
            }
          >
            <ButtonBase className={styles.edit} onClick={handleToggle}>
              CANCEL
            </ButtonBase>
            <ButtonBase
              onClick={handleConfirm}
              disabled={isSubmitting}
              className={styles.btmBtn}
            >
              {isSubmitting ? (
                <CircularProgress color="success" size="20px" />
              ) : isGroupAdmin && isExit ? (
                "ASSIGN & LEAVE"
              ) : (
                "CONFIRM"
              )}
            </ButtonBase>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default DeleteDialog;
